export default __webpack_public_path__ + "static/media/TRUCK2.f1cd1eee.jpg";